<template>
  <div>
    <ca-header heading="Kaufschutz Tarif">
      <template #alert>
        <transition name="slide-fade">
          <ca-alert
            v-if="!!saveErrorMessage"
            variant="danger"
            :message="saveErrorMessage"
            @close="saveErrorMessage = null"
          />
        </transition>
        <transition name="slide-fade">
          <ca-alert
            v-if="!!saveSuccessMessage"
            variant="success"
            :message="saveSuccessMessage"
            @close="saveSuccessMessage = null"
          />
        </transition>
        <transition name="slide-fade">
          <ca-alert
            v-if="showFormInvalidHint"
            variant="info"
            message="Es sind noch nicht alle erforderlichen Felder ausgefüllt"
            @close="showFormInvalidHint = null"
          />
        </transition>
      </template>
      <template #buttonSpace>
        <button
          class="btn btn-success text-white"
          @click="save()"
        >
          Speichern
        </button>
      </template>
    </ca-header>
    <div class="container-fluid px-4 pt-4">
      <KaufschutzForm
        v-if="!loading"
        :kaufschutz-rate="kaufschutzRate"
      />
    </div>
  </div>
</template>

<script>
import CaHeader from '@/components/Layout/Header'
import KaufschutzForm from './components/KaufschutzForm'

export default {
  $_veeValidate: {
    validator: 'new' // give me my own validator scope.
  },
  name: 'KaufschutzRateEdit',
  components: {
    KaufschutzForm,
    CaHeader
  },
  data () {
    return {
      loading: false,
      loadingError: null,
      kaufschutzRate: null,
      savePending: false,
      saveError: null,
      saveSuccessMessage: null,
      saveErrorMessage: null,
      showFormInvalidHint: false
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler: 'fetchData'
    }
  },
  methods: {
    async fetchData () {
      try {
        this.loading = true
        this.kaufschutzRate = await this.$store.dispatch('kaufschutz-rates/get', this.$route.params.kaufschutzRateId)
      } catch (error) {
        this.loadingError = error
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    async save () {
      try {
        const valid = await this.$validator.validateAll()
        if (this.userSavePending) {
          return
        }
        if (!valid) {
          this.showFormInvalidHint = true
          return
        }
        this.savePending = true
        this.saveErrorMessage = null
        this.showFormInvalidHint = false
        await this.kaufschutzRate.save()
        this.savePending = false
        this.saveSuccessMessage = 'Speichern erfolgreich'
      } catch (error) {
        this.saveErrorMessage = error.message
        this.saveError = error
        console.error(error)
      } finally {
        this.savePending = false
      }
    }
  }
}
</script>
